<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
import { getInvitation, acceptInvitation } from "@/services/api/Invitations.js"

import LocalStorage from "@/controller/LocalStorage.js";

import YLoader from "../common/loaders/YLoader.vue";
import Separator from '@/components/common/utils/Separator.vue';

import YBtn from "../common/form/YBtn/YBtn.vue";

import InvitationStatus from "@/components/invitation/components/InvitationStatus.vue";
import InvitationBranch from '@/components/invitation/components/InvitationBranch.vue';
import InvitationDataClients from "./components/data/InvitationDataClients.vue";
import InvitationDataClientVehicles from '@/components/invitation/components/data/client/vehicles/InvitationDataClientVehicles.vue';
import { useToast } from 'maz-ui';

const toast = useToast()
const { t } = useI18n();
const userKey = ref(LocalStorage.getKey());
const router = useRouter();



const loading = ref(true);
const invitationInfo = ref(null);
const loaderButton = ref(false);
const disabledButton = ref(false);
const errorMsg = ref(false)
const showError = ref(false);
const okMsg = ref('');
const showOk = ref(false);

const path =  router.currentRoute.value.params.id;

getInvitation({ path: path }).then((res) => {
    if (res.errors){
          router.push({ name: "notFound" })
          return;
    }
    loading.value = false;
    invitationInfo.value = res;
    return res;
});

function showToast (msg,options,state) {
    if (state  == 'error'){
        const toastMessage = toast.error(msg, options);
    }else{
        const toastMessage = toast.success(msg, options);
    }
    
}

function sendAcceptInvitation() {
    showError.value = false;
    errorMsg.value = "";
    loaderButton.value = true;
    disabledButton.value = "disabled";
    acceptInvitation({ k: userKey.value, path: path })
    .then((res) => {
        loaderButton.value = false;
        if(res && res.errors) {
            if(res.errors[0].error == 'DOES_NOT_EXISTS') {
                showToast(t('error.INVITATION_DOES_NOT_EXISTS'), {
                    position: 'bottom-right',
                    timeout: 3000,
                    class: 'toast-sync'
                }, 'error');
            }
            if(res.errors[0].error == 'ALREADY_ACCEPTED') {
                showToast(t('error.ALREADY_ACCEPTED'), {
                    position: 'bottom-right',
                    timeout: 3000,
                    class: 'toast-sync'
                }, 'error');
            }
            disabledButton.value = false;
        } else {
            showToast(t('invitations.invitation_redirect'), {
                position: 'bottom-right',
                timeout: 3000,
                class: 'toast-sync'
            }, 'success');
            setTimeout(() => {
                showOk.value = false;
                router.push("/");
            }, 3000);
        }
    });
}


const isSmallScreen = ref(window.innerWidth < 1025 && window.matchMedia("(orientation: portrait)").matches);

const updateScreenSize = () => {
    isSmallScreen.value = window.innerWidth < 1025 && window.matchMedia("(orientation: portrait)").matches;
};

onMounted(() => {
    window.addEventListener('resize', updateScreenSize);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateScreenSize);
});

const secondTitleText = computed(() => {
    if (!invitationInfo.value || !invitationInfo.value.data) {
        return t('invitations.invitation_pending'); // Texto predeterminado mientras se cargan los datos
    }
    return isSmallScreen.value
        ? `${t('invitations.invitation_pending')}`
        : `${t('invitations.invitation_from')} ${invitationInfo.value.data.invitationEmail || ''}`;
});


</script>

<template>

    <div class="backgroud-saver"></div>
    <div class="invitation_wrapper">
        <div class="invitation__title">
            <div class="title title-color"> {{ t('invitations.pending_invitation')}}</div>
            <Separator />
        </div>
    
        <div class="w-100 invitation__wrapper">
            <div class="invitation__content">
                <div class="invitation__content_loader" v-if="loading">
                    <YLoader />
                </div>
                <div class="invitation__content_info" v-else>
                    <div class="second-title">
                        {{ secondTitleText }}
                    </div>
                    <div class="content-info">
                        <InvitationStatus class="invitation-status" :status="invitationInfo.status"
                            :data="invitationInfo.data" />
                        <InvitationBranch class="invitation-branch" :branch="invitationInfo.data.dealerName" />
                        <InvitationDataClients class="invitation-client" :clients="invitationInfo.data.clients" />
                    </div>
                </div>
            </div>
            <div class="invitation__button">
                <YBtn primary :loading="loaderButton" :disabled="disabledButton" :label="t('invitations.accept_invitation')"
                    :rounded="true" roundedSize="full" @click="sendAcceptInvitation" size="md">
                </YBtn>
            </div>
        </div>
        <div class="vehicles-content">
            <div class="vehicles__title subtitle-color">
                {{ $t('vehicle.vehicle_info') }}
            </div>
                <div v-for="client in invitationInfo?.data?.clients">
                    <InvitationDataClientVehicles :vehicles="client.vehicles" />
                </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.backgroud-saver{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #EFF3F3;
    
    
}

.invitation_wrapper{
    height: 90dvh;
}

.invitation__title{
    margin-top: 1rem;
    margin-bottom: 2rem;
}

.invitation__button{
    justify-self: end; 
    position: absolute; 
    right: 25px; 
    top: 25px; 
    z-index: 1;
}

.invitation__wrapper {
    display: block;
    padding: 25px 25px 20px;
    background-color: #ffffff;
    border-radius: 20px;
    font-family: 'CircularStd-Book';
    font-size: 14px;
    font-weight: 100 !important;
    
}

    .title {
        font-family: "CircularStd-Bold";
        font: normal normal normal;
        font-size: 32px;
        letter-spacing: -2px;
        color: #153440;
        opacity: 1;
    }

    .second-title{
        margin-bottom: 1.5rem;
        max-width: 80%;
        
        font-family: "CircularStd-Bold";
        font: normal normal normal;
        font-size: 28px;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
    }
    

    

    .invitation__content {
        min-height: 200px;
        padding-left: 2rem;
        padding-top: 1rem;
        .invitation__content_loader {
            min-height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .content-info{
        display: flex;
        flex-direction: row;
        gap: 10rem;
        

    }

.vehicles__title{
    font-family: 'CircularStd-Book';
    font-size: 22px;
    font-weight: 700;
    margin-top: 2rem;
    margin-left: 1rem;
    margin-bottom: 0.5rem;
    color: #153440;

}



@media (max-width: 576px) {
    .invitation__wrapper{
        margin-top: 2rem;
        font-size: 18px;
        

        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
    }


    .invitation__title {
        display: none;
        flex-direction: column;
        padding-bottom: 30px;
        
    }

    .vehicles-content {
        display: none;
        
    }

    .content-info {
        flex-direction: column;
        gap: 2rem;
    }

    .invitation-status{
        margin-top: 0rem;
    }

    .invitation__content {
        padding-left: 0.5rem;
    }
    .invitation-branch{
        bottom: 2rem;
    }

    .invitation-client{
        bottom: 2rem;
    }


    .invitation__button{
        position: relative;
        justify-self: center; 
        right: 0; 
        top: 0; 
        margin-top: 2rem;
        z-index: 1;
    }

}


@media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    
    .content-info {
        
        display: grid !important;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;

        .invitation-status {
            grid-column: 1 / -1; 
        }

        .invitation-branch {
            grid-column: 1 / 2; 
        }

        .invitation-client {
            grid-column: 2 / 3; 
            height: 170px;
        }
    }
    .second-title{
        max-width: 70%;
    }

    .invitation__button{
        top: 2rem;
        right: 3rem;
    }

}

@media (min-width: 1024px) and (max-width: 1400px) and (orientation: landscape) {

    .content-info {
        
        display: grid !important;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
    }

    .invitation-status {
        grid-column: 1 / -1; 
    }

    .invitation-branch {
        grid-column: 1 / 2; 
    }

    .invitation-client {
        grid-column: 2 / 3; 
        height: 170px;
    }
    

    .second-title{
        max-width: 70%;
    }

    .invitation__button{
        top: 2rem;
        right: 3rem;
    }

}

</style>